import type { JSX } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import PrivateRoute from './PrivateRoute';
import { ViewProvider } from '../components/layout/ViewContext'; // Import ViewProvider
import AuditLogList from '../pages/admin/auditLogs/List';
import BulkEmailCreate from '../pages/admin/bulkEmail/Create';
import BulkEmailEdit from '../pages/admin/bulkEmail/Edit';
import BulkEmailList from '../pages/admin/bulkEmail/List';
import CompanyInfoCreate from '../pages/admin/companyInfo/Create';
import CompanyInfoEdit from '../pages/admin/companyInfo/Edit';
import CompanyInfoList from '../pages/admin/companyInfo/List';
import Dashboard from '../pages/admin/Dashboard';
import MemberCreate from '../pages/admin/member/Create';
import MemberEdit from '../pages/admin/member/Edit';
import MemberList from '../pages/admin/member/List';
import UserCreate from '../pages/admin/users/Create';
import UserEdit from '../pages/admin/users/Edit';
import UsersList from '../pages/admin/users/List';
import ForgotPassword from '../pages/public/ForgotPassword';
import Login from '../pages/public/Login';
import ResetPassword from '../pages/public/ResetPassword';
import SiteSurvey from '../pages/public/SiteSurvey';
import Unsubscribe from '../pages/public/Unsubscribe';

import SurveyInviteList from '../pages/admin/surveyInvite/List';
import SurveyInviteCreate from '../pages/admin/surveyInvite/Create';
import SurveyInviteEdit from '../pages/admin/surveyInvite/Edit';

import SiteSurveyResponseList from '../pages/admin/siteSurveyResponse/List';
import SiteSurveyResponseCreate from '../pages/admin/siteSurveyResponse/Create';
import SiteSurveyResponseEdit from '../pages/admin/siteSurveyResponse/Edit';

// Import route here

const AppRouter = (): JSX.Element => (
  <ViewProvider>
    {' '}
    {/* Wrap all routes in the ViewProvider */}
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/unsubscribe" element={<Unsubscribe />} />
        <Route path="/survey/:token" element={<SiteSurvey />} />

        {/* Protected admin routes */}
        <Route
          path="/admin/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/auditlogs"
          element={
            <PrivateRoute>
              <AuditLogList />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/companyinfo"
          element={
            <PrivateRoute>
              <CompanyInfoList />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/companyinfo/create"
          element={
            <PrivateRoute>
              <CompanyInfoCreate />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/companyinfo/:id"
          element={
            <PrivateRoute>
              <CompanyInfoEdit />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/bulkemails"
          element={
            <PrivateRoute>
              <BulkEmailList />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/bulkemails/create"
          element={
            <PrivateRoute>
              <BulkEmailCreate />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/bulkemails/:id"
          element={
            <PrivateRoute>
              <BulkEmailEdit />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/users"
          element={
            <PrivateRoute>
              <UsersList />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/users/create"
          element={
            <PrivateRoute>
              <UserCreate />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/users/:id"
          element={
            <PrivateRoute>
              <UserEdit />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/members"
          element={
            <PrivateRoute>
              <MemberList />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/members/create"
          element={
            <PrivateRoute>
              <MemberCreate />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/members/:id"
          element={
            <PrivateRoute>
              <MemberEdit />
            </PrivateRoute>
          }
        />

                    <Route
                        path="/admin/surveyinvites"
                        element={
                            <PrivateRoute>
                                <SurveyInviteList/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/surveyinvites/create"
                        element={
                            <PrivateRoute>
                                <SurveyInviteCreate/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/surveyinvites/:id"
                        element={
                            <PrivateRoute>
                                <SurveyInviteEdit/>
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/admin/sitesurveyresponses"
                        element={
                            <PrivateRoute>
                                <SiteSurveyResponseList/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/sitesurveyresponses/create"
                        element={
                            <PrivateRoute>
                                <SiteSurveyResponseCreate/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/sitesurveyresponses/:id"
                        element={
                            <PrivateRoute>
                                <SiteSurveyResponseEdit/>
                            </PrivateRoute>
                        }
                    />


      </Routes>
    </Router>
  </ViewProvider>
);

export default AppRouter;
